// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"f9247199","386":"ce15fac4","732":"3695c284","977":"92003ddf"}[chunkId] + ".chunk.js";
};